import React, { Component } from "react";
import { Divider, Row, Layout, Button } from "antd";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import BestCatsTable from "../../table/BestCatsTable";
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
  VKShareButton,
  FacebookIcon,
  RedditIcon,
  TwitterIcon,
  VKIcon,
} from "react-share";
import VenatusAd from "../../ads/VenatusAd";
import VenatusAdWithPlaceholder from "../../ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_LEADERBOARD,
  VENATUS_MOBILE_INCONTENT,
  VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL,
  VENATUS_RICH_MEDIA,
} from "../../utilities/constants";

const shareURL = "https://mygamatoto.com/best-cats-for-attack";
const { Content } = Layout;
// const convertBasedOnLevel = require("../../table/calc-stats");

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class Attack extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      compareCatsLevels: 30,
    };
  }
  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    document.title = "Best Cats for Attack | Battle Cats Wiki for Cat Stats";
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }

    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    const bestCats = [
      {
        key: "227-3",
        name: "Mad Doctor Klay",
        number: "227-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 23250,
        damage: 24038,
        range: 430,
        kb: 2,
        speed: 8,
        dps: 3018,
        target: "Area",
        tba: "7.97",
        anim: "2.33",
        spawn: "164.87",
        cost: 6135,
        ability:
          "u1Against alienu2: u1Attacks onlyu2b1 alienb2\nu1Not affected byu2: b1Weakenb2, b1Freezeb2, b1Slowb2, b1Knockbackb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "472-1",
        name: "Heracrist",
        number: "472-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 15000,
        damage: 22500,
        range: 360,
        kb: 2,
        speed: 4,
        dps: 2848,
        target: "Single",
        tba: "7.90",
        anim: "3.87",
        spawn: "74.87",
        cost: 4500,
        ability:
          "u1Against floatingu2: b1Strongb2 (inflicts 1.5x damage, takes only 0.5x damage)\r\nu1Not affected byu2: b1Slowb2, b1Warpb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "126-3",
        name: "Immortal Shingen",
        number: "126-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 19750,
        damage: 18912,
        range: 470,
        kb: 2,
        speed: 7,
        dps: 2468,
        target: "Area",
        tba: "7.67",
        anim: "3.70",
        spawn: "161.53",
        cost: 5985,
        ability:
          "u1Against black, alienu2: u1Attacks onlyu2b1 blackb2,b1 alienb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "171-2",
        name: "Tesalan Pasalan",
        number: "171-2",
        form: "Evolved",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3000,
        damage: 18250,
        range: 620,
        kb: 1,
        speed: 4,
        dps: 2245,
        target: "Single",
        tba: "8.13",
        anim: "3.50",
        spawn: "324.87",
        cost: 4500,
        ability:
          "u1General Abilitiesu2: b1Criticalb2 (10% chance of a critical hit)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "107-3",
        name: "Divine Kai",
        number: "107-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 28500,
        damage: 17475,
        range: 175,
        kb: 2,
        speed: 16,
        dps: 1665,
        target: "Area",
        tba: "10.50",
        anim: "2.53",
        spawn: "71.53",
        cost: 3990,
        ability:
          "u1Against floatingu2: b1Resistantb2 (only takes 0.25x damage) \nu1General Abilitiesu2: b1Surviveb2 (100% chance to survive a lethal strike)\nu1Not affected byu2: b1Knockbackb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "332-1",
        name: "Bunny & Canard",
        number: "332-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 17000,
        damage: 16025,
        range: 430,
        kb: 2,
        speed: 8,
        dps: 2012,
        target: "Area",
        tba: "7.97",
        anim: "2.33",
        spawn: "158.20",
        cost: 5910,
        ability:
          "u1Against red, blacku2: u1Attacks onlyu2b1 redb2,b1 blackb2\nu1Not affected byu2: b1Freezeb2, b1Slowb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "520-1",
        name: "Lasvoss",
        number: "520-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 5000,
        damage: 15000,
        range: 320,
        kb: 2,
        speed: 8,
        dps: 900,
        target: "Area",
        tba: "16.67",
        anim: "2.57",
        spawn: "71.53",
        cost: 5400,
        ability:
          "u1General Abilitiesu2: b1Strengthenb2 (attack power increases by 50% at 1% health) b1Surviveb2 (100% chance to survive a lethal strike) b1Savage Blowb2 (30% chance to inflict an attack with 2x damage to non-Metal enemies)\nu1Not affected byu2: b1Weakenb2, b1Freezeb2, b1Slowb2, b1Knockbackb2, b1Curseb2, b1Warpb2, b1Waveb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "044-3",
        name: "Cat Machine Mk 3",
        number: "044-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 22500,
        damage: 13888,
        range: 190,
        kb: 1,
        speed: 15,
        dps: 1560,
        target: "Area",
        tba: "8.90",
        anim: "5.60",
        spawn: "64.87",
        cost: 3600,
        ability:
          "u1Against red, alienu2: b1Resistantb2 (only takes 0.25x damage) \nu1General Abilitiesu2: b1Wave Shieldb2 (Protects units behind them from shockwaves)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "026-3",
        name: "Awakened Bahamut Cat",
        number: "026-3",
        form: "True",
        rarity: "Special",
        level: 1,
        health: 3750,
        damage: 13750,
        range: 200,
        kb: 6,
        speed: 60,
        dps: 4435,
        target: "Area",
        tba: "3.10",
        anim: "0.17",
        spawn: "98.20",
        cost: 4500,
        ability:
          "u1General Abilitiesu2: b1Multi-hit attackb2 (Attacks thrice consecutively)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "356-3",
        name: "Orbital Annihilator Ragnarok",
        number: "356-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 6000,
        damage: 13000,
        range: 470,
        kb: 8,
        speed: 8,
        dps: 1822,
        target: "Area",
        tba: "7.13",
        anim: "4.43",
        spawn: "178.20",
        cost: 4500,
        ability:
          "u1Against red, black, floating, metal, angel, alien, zombie, relicu2: u1Attacks onlyu2b1 redb2,b1 blackb2,b1 floatingb2,b1 metalb2,b1 angelb2,b1 alienb2,b1 zombieb2,b1 relicb2 \nu1General Abilitiesu2: b1Zombie Killerb2 (Stops zombies from reviving) b1Omni Strikeb2 (Effective range -470~470)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
    ];

    // console.log(typeof(bestCats))

    return (
      <div>
        <div className="pagetitle">
          <h1 style={{ padding: "10px 0 0 0", marginBottom: "6px" }}>
            Best Cats
          </h1>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content className="flexible-width">
            <Row style={{ padding: "16px 0 0 0" }}>
              <div>
                {this.state.viewportWidth > 1024 ? (
                  <VenatusAdWithPlaceholder
                    placementId={VENATUS_DESKTOP_LEADERBOARD}
                  />
                ) : ( ''
                  // <VenatusAdWithPlaceholder
                  //   placementId={VENATUS_MOBILE_LEADERBOARD}
                  // />
                )}
                <h2 style={{ marginTop: "12px", fontSize: "24px" }}>
                  Best Cats for Attack
                </h2>
                <p></p>
                <div>
                  What are the best cats in The Battle Cats for damage? Which
                  battle cats have the highest attack?
                </div>
                <p></p>
                <div>
                  Comparing the stats for the top 10 cats gives us the list
                  below.
                </div>
                <p></p>
                <i>Last updated: 1 March 2021</i>
              </div>
            </Row>

            <Row style={{ margin: "16px 0 0 0" }}>
              <FacebookShareButton
                url={shareURL}
                style={{ marginRight: "0.25rem" }}
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareURL}
                title="MyGamatoto - Best Cats for Attack"
                style={{ marginRight: "0.25rem" }}
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <RedditShareButton
                url={shareURL}
                style={{ marginRight: "0.25rem" }}
              >
                <RedditIcon size={32} round />
              </RedditShareButton>
              <VKShareButton
                url={shareURL}
                title="MyGamatoto - Best Cats for Attack"
                style={{ marginRight: "0.25rem" }}
              >
                <VKIcon size={32} round />
              </VKShareButton>
            </Row>
            {this.state.viewportWidth > 1024 ? (
              ""
            ) : (
              <div style={{margin: "10px 0 0 0"}}>
              <div class="vm-placement" id="vm-av" data-format="isvideo"></div>
              </div>
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  10.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[9].number +
                      ".png"
                    }
                    alt={bestCats[9].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[9].number.slice(0, 3) +
                          "/" +
                          bestCats[9].name
                        }
                      >
                        {bestCats[9].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Only the most elite among the Cat Army troops can be trusted
                  with this weapon of overwhelming power. Massive area damage vs
                  traited enemies only.
                  <p></p>
                  <b>Pros: </b>Great against all enemies.
                  <p></p>
                  <b>Cons: </b>Doesn't attack whites. There are also better
                  all-rounded ubers, although this is a great starter uber.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[9].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Orbital Annihilator Ragnarok"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            {/* <div id="waldo-tag-14680"></div> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  9.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[8].number +
                      ".png"
                    }
                    alt={bestCats[8].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[8].number.slice(0, 3) +
                          "/" +
                          bestCats[8].name
                        }
                      >
                        {bestCats[8].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  They say the power to obliterate Earth is already his. Freed
                  of the suit which shackled his power, his power and speed is
                  unmatched (Area Attack)
                  <p></p>
                  <b>Pros: </b>Versatile damage dealer, and your only hope for
                  many of those 4-star SoL stages. Also great for speed runs.
                  <p></p>
                  <b>Cons: </b>Short range, so tends to die quickly.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[8].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Awakened Bahamut Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  8.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[7].number +
                      ".png"
                    }
                    alt={bestCats[7].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[7].number.slice(0, 3) +
                          "/" +
                          bestCats[7].name
                        }
                      >
                        {bestCats[7].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  The next generation of battle tech, MS:RX-Ω has slipped into
                  the hands of the Cat Army! Resists Red/Alien attacks, immune
                  to Waves.
                  <p></p>
                  <b>Pros: </b>Has wave shield. Not too expensive, with fast
                  recharge.
                  <p></p>
                  <b>Cons: </b>Pretty poor range.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[7].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Cat Machine Mk 3"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  7.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[6].number +
                      ".png"
                    }
                    alt={bestCats[6].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[6].number.slice(0, 3) +
                          "/" +
                          bestCats[6].name
                        }
                      >
                        {bestCats[6].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Incarnation of Evil summoned to eradicate the forces of Good.
                  May strike a Savage Blow imbued with dark power. Survives
                  once, stronger after taking damage.
                  <p></p>
                  <b>Pros: </b>Not affected by many things.
                  <p></p>
                  <b>Cons: </b>Not sure what the point of evolving it is.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[6].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Lasvoss"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "16px 0 8px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  6.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[5].number +
                      ".png"
                    }
                    alt={bestCats[5].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[5].number.slice(0, 3) +
                          "/" +
                          bestCats[5].name
                        }
                      >
                        {bestCats[5].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A young mage found an easter egg that
                  hatched a delightful duck-thing to be his new friend! (Area
                  Atk) Only attacks Red/Black, with massive damage.
                  <p></p>
                  <b>Pros: </b>The other version of Mad Doctor Klay, tackling
                  red, black and zombie (evolved form) enemies
                  <p></p>
                  <b>Cons: </b>Also the weaker version of Mad Doctor Klay, with
                  only 2/3 of its damage. Equivalent to the normal and evolved
                  form of Mad Doctor Klay though, so this isn't so bad.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[5].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Bunny & Canard"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  5.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[4].number +
                      ".png"
                    }
                    alt={bestCats[4].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[4].number.slice(0, 3) +
                          "/" +
                          bestCats[4].name
                        }
                      >
                        {bestCats[4].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  If any cute guy is your type, is that really a type? Always
                  travels via her trusty Boarborg (Area Atk) Reduced damage from
                  Flying, Survives Once.
                  <p></p>
                  <b>Pros: </b>Perfect meatshield. Doesn't take too long to
                  recharge, and not that expensive.
                  <p></p>
                  <b>Cons: </b>Time between attacks is quite lengthy.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[4].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Divine Kai"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  4.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[3].number +
                      ".png"
                    }
                    alt={bestCats[3].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[3].number.slice(0, 3) +
                          "/" +
                          bestCats[3].name
                        }
                      >
                        {bestCats[3].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Are you kidding me?! Seems like this one does massive damage
                  (sometimes critical) to just one enemy.
                  <p></p>
                  <b>Pros: </b>Fantastic range. Can crit too, so great at
                  tackling high-health metal enemies like the Metal Cyclone.
                  <p></p>
                  <b>Cons: </b>Takes very long to attack, plus targets only
                  single enemies so has a high chance of missing.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[3].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Tesalan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}

            <Row style={{ padding: "16px 0 8px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  3.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[2].number +
                      ".png"
                    }
                    alt={bestCats[2].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[2].number.slice(0, 3) +
                          "/" +
                          bestCats[2].name
                        }
                      >
                        {bestCats[2].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A master tactician of overwhelming power
                  who is cursed by the Legendary Cat Sword. Area attacks only
                  damage Black/Aliens.
                  <p></p>
                  <b>Pros: </b>Pretty decent range, but nothing else that stands
                  out.
                  <p></p>
                  <b>Cons: </b>Only attacks black or aliens. Pretty costly.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[2].damage}  */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Immortal Shingen"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  2.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[1].number +
                      ".png"
                    }
                    alt={bestCats[1].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[1].number.slice(0, 3) +
                          "/" +
                          bestCats[1].name
                        }
                      >
                        {bestCats[1].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Holy android created by 12 archangels. Rumors say that its
                  powers unbalanced could undo reality. Strong vs. Floating
                  enemies.
                  <p></p>
                  <b>Pros: </b>Even better when paired against floating or
                  aliens (evolved form).
                  <p></p>
                  <b>Cons: </b>Unfortunately, it's a collab cat.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[1].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Heracrist"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "0px 0 0px 0" }}>
              <Row style={{ padding: "0px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  1.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[0].number +
                      ".png"
                    }
                    alt={bestCats[0].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[0].number.slice(0, 3) +
                          "/" +
                          bestCats[0].name
                        }
                      >
                        {bestCats[0].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Picked up an online degree in occult anatomy. 1st attempt at a
                  soul transplant: GREAT SUCCESS!(?) Delivers extreme damage,
                  but only to Aliens/bases!
                  <p></p>
                  <b>Pros: </b>Overwhelming strength.
                  <p></p>
                  <b>Cons: </b>Only attacks aliens. One of the most expensive
                  cats.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[0].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Mad Doctor Klay"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "6px 0 6px 0" }}>
              <Divider />
              <h3>Compare all 10 cats below</h3>
              <BestCatsTable
                selectedCats={bestCats}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row
              style={{
                padding: "24px 20px 18px 20px",
                backgroundColor: "#ffa50038",
                textAlign: "center",
                margin: "0 0 8px 0",
              }}
            >
              <div style={{ fontSize: "16px" }}>
                Want to compare the stats of any cat in The Battle Cats?
              </div>
              <Divider
                style={{ backgroundColor: "orange", marginTop: "12px" }}
              ></Divider>
              <Button href="/comparecats" size="large">
                Compare more cats
              </Button>
            </Row>
          </Content>
        </Layout>
        {this.state.viewportWidth > 1024 ? (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL}
              style={{ display: "none" }}
            />
          </div>
        ) : (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA}
              style={{ display: "none" }}
            />
          </div>
        )}
        {/* <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="6015153906"
        ></HorizontalAdPopup> */}
        {/* <div id="waldo-tag-14678"></div> */}
      </div>
    );
  }
}

export default Attack;

Attack.propTypes = {
  applyViewportChange: PropTypes.number,
};

Attack.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components/content/bestcats/Attack.js